import { toPackageName } from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';

export const PROJECT_DETAILS_APP_NAME = 'project-settings-apps.details-page';
export const TIME_TO_LOAD_MARK_KEY = 'timeToLoad';
export const READY_MARK_KEY = 'readyToInteract';

export const PROJECT_NAME_MIN_LENGTH = 2;

export const PROJECT_KEY_MIN_LENGTH = 2;
export const PROJECT_KEY_PATTERN = /^([A-Z][A-Z0-9]+)$/;

export const PROJECT_URL_MAX_LENGTH = 255;

// When project name is less than PROJECT_NAME_MIN_LENGTH
export const TOO_SHORT_PROJECT_NAME_ERROR = 'TOO_SHORT_PROJECT_NAME_ERROR' as const;

// When project key changes
export const PROJECT_KEY_CHANGE_WARNING = 'PROJECT_KEY_CHANGE_WARNING' as const;

// When project name is greater than the project name max length (this value is fetched from the server)
export const TOO_LONG_PROJECT_NAME_ERROR = 'TOO_LONG_PROJECT_NAME_ERROR' as const;

// When project key is empty
export const REQUIRED_PROJECT_KEY_ERROR = 'REQUIRED_PROJECT_KEY_ERROR' as const;

// When project key is greater than the project key max length (this value is fetched from the server)
export const TOO_LONG_PROJECT_KEY_ERROR = 'TOO_LONG_PROJECT_KEY_ERROR' as const;

// When project url is greater than the project url max length (this value is hardcoded in FE)
export const TOO_LONG_PROJECT_URL_ERROR = 'TOO_LONG_PROJECT_URL_ERROR' as const;

// When project url does not start with https:// or http://
export const INVALID_URL_PATTERN = 'INVALID_URL_PATTERN' as const;

// When project key does not match PROJECT_KEY_PATTERN
export const INVALID_PATTERN_PROJECT_KEY_ERROR = 'INVALID_PATTERN_PROJECT_KEY_ERROR' as const;

// When project team type free text has validation error
export const PROJECT_TEAM_TYPE_FREE_TEXT_ERROR = 'PROJECT_TEAM_TYPE_FREE_TEXT_ERROR' as const;

export const ASSIGNEE_TYPE_UNASSIGNED = 'UNASSIGNED' as const;
export const ASSIGNEE_TYPE_PROJECT_LEAD = 'PROJECT_LEAD' as const;

export const APP_ID = 'project-settings-apps.details';
export const PACKAGE_NAME = toPackageName('jiraProjectDetails');
